import React from 'react'
import styled, {useTheme} from 'styled-components'
import IconButton from 'lib/ui/IconButton'
import {PlusIcon} from 'lib/ui/Icon'

interface AddIconButtonProps {
  onClick?: () => void
  className?: string
  color?: string
  showing?: boolean
  ['aria-label']?: string
  type?: 'button' | 'submit'
}

export default function AddIconButton(props: AddIconButtonProps) {
  const theme = useTheme()
  const {
    color = theme.colors.primary,
    type = 'button',
    showing,
    className,
    onClick,
  } = props

  if (!showing) {
    return null
  }

  return (
    <IconButton
      className={className}
      onClick={onClick}
      aria-label={props['aria-label']}
      type={type}
    >
      <Box>
        <PlusIcon color={color} iconSize={24} />
      </Box>
    </IconButton>
  )
}

const Box = styled.div`
  background: #ffffff;
  display: inline-flex;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
`
